import ProfileOverview from "layouts/pages/profile/profile-overview";
import Settings from "layouts/pages/account/settings";
import AddNewSystemUser from "layouts/systemUsers/addNewSystemUser";
import GeneralCodesTable from "layouts/contents/generalCodesList";
import QuestionnaireList from "layouts/questionnaire/questionnaireList";
import QuestionList from "layouts/questionnaire/questionList";
import BatchList from "layouts/questionnaire/batchList";
import AppSettings from "layouts/appSettings";
import MainDashboard from "layouts/dashboard";
import AdminTasks from "layouts/adminTasks";
import Logs from "layouts/logs";
import ViewRoles from "layouts/roles/list";
import Translations from "layouts/translations";
import Positions from "layouts/positions";
import DBCopy from "layouts/dbCopy";
import SignInIllustration from "layouts/signIn";
import ShidduchRequests from "layouts/matchmakers/shidduchRequests";
import ShidduchRequestView from "layouts/matchmakers/shidduchRequestView";
import MMProfileAndSettings from "layouts/smeProfiles/profileAndSettings";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import EmptyPage from "layouts/Empty";
import CustomerSupportTickets from "layouts/customerSupport/list/tickets";
import CustomerSupportSettings from "layouts/customerSupport/settings";
import CustomerSupportViewTicket from "layouts/customerSupport/view/viewTicket";
import LanguageSettings from "layouts/translations/languagesList";
import LangTranslations from "layouts/translations/LangTranslations";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

// Otis Admin PRO React components
// @mui icons
import Icon from "@mui/material/Icon";
import { layouts } from "chart.js";
// Images
import md5 from "md5";
import { DynamicFeed, Layers, NoteAdd, NoteAlt, Notes } from "@mui/icons-material";
import SMEProfiles from "layouts/smeProfiles/profiles";
import ViewSystemUsersList from "layouts/systemUsers/viewUsers";
import ViewSystemUser from "layouts/systemUsers/viewSystemUser";
import ViewEndUsersList from "layouts/endUsers/endUsers";
import ViewEndUser from "layouts/endUsers/viewEndUser";
import ViewBrandsList from "layouts/brands";
import ViewBrand from "layouts/brands/viewBrand";

import RolePermissions2 from "layouts/roles/viewRole";
import { ErrorPage } from "layouts/error/errorPage";
import ViewEndUserIntroductions from "layouts/endUsers/endUserIntroductions";
import IntroductionsScreen from "layouts/introductions/Introductions";
import ViewIntroduction from "layouts/introductions/viewIntroduction";
import { ScreensList } from "layouts/screens/screensList";
import { ScreensView } from "layouts/screens/screenView";
import { PredictorRelationsList } from "layouts/predictorRelations/predictorRelationsList";
import { CommsList } from "layouts/comms/commsList";
import { CommsView } from "layouts/comms/viewComm";
import ReportPage from "layouts/reports";
import { SystemSettings } from "layouts/appSettings/system";
import EndUsersMatchScores from "layouts/endUsers/endUserMatchScores";
import { AppFeature, SettingsTypes } from "utils/settingsUtils";
import { CreateNewTicket } from "layouts/customerSupport/create";
import { TicketSource } from "models/customer-supports/Ticket";
import { AttributesList } from "layouts/attributes/attributesList";
import ViewAttribute from "layouts/attributes/viewAttribute";
import { AutocompleteAnswers } from "layouts/attributes/autocompleteAnswers";
import ViewQuestion from "layouts/questionnaire/question";
import { ContentsList } from "layouts/contents/contentsList";
import { PageNumber } from "accessNumbers";
import { ContentsView } from "layouts/contents/viewContent";
import { ContentTypes } from "layouts/contents/contentsList/types";
import { AnswersListPage } from "layouts/questionnaire/responsesList/answersListPage";
import EditBatchContent from "layouts/questionnaire/batchContent/editBatchContent";
import ProfileAssetsList from "layouts/appSettings/ProfileAssetsList";
import { BoSettingsPagesList } from "layouts/boSettingsPages/boSettingsPagesList";
import { BoSettingsPagesView } from "layouts/boSettingsPages/viewBoSettingsPage";
import { AISimulationsList } from "layouts/AISimulations/AISimulationsList";
import { AISimulationsView } from "layouts/AISimulations/viewAISimulation";
import DeclinesList from "layouts/matchmakers/declinesList";
import { GroupsList } from "layouts/groups/groupsList";
import { GroupsView } from "layouts/groups/viewGroup";
import { TagRulesList } from "layouts/tagRules/tagRulesList";
import { TagRulesView } from "layouts/tagRules/viewTagRule";

const MDAvatar = require("components/MDAvatar").default;

const d = new Date();
const today = md5(
  d.getFullYear() +
  "-" +
  ("0" + (d.getMonth() + 1)).slice(-2) +
  "-" +
  ("0" + d.getDate()).slice(-2) +
  "T" +
  ("0" + d.getHours()).slice(-2) +
  ":" +
  ("0" + d.getMinutes()).slice(-2)
);

export type MyRoute = {
  type?: string;
  name?: string;
  key?: string;
  icon?: any;
  route?: string;
  feature?: AppFeature;
  component?: any;
  accessNumber?: number;
  collapse?: MyRoute[];
  hide?: boolean;
  href?: string;
  onclick?: any;
  function?: any;
  noCollapse?: boolean;
  notificationKey?: string;
  title?: string;
};


const routes: MyRoute[] = [
  {
    type: "collapse",
    name: "User",
    key: "brooklyn-alice",
    accessNumber: PageNumber.User,
    icon: (
      <MDAvatar
        src={
          "https://e7.pngegg.com/pngimages/799/987/png-clipart-computer-icons-avatar-icon-design-avatar-heroes-computer-wallpaper-thumbnail.png"
        }
        alt="User"
        size="sm"
      />
    ),
    collapse: [
      {
        name: "My Profile",
        key: "my-profile",
        route: "/systemUsers/me",
        component: <ViewSystemUser />,
        accessNumber: PageNumber.MyProfile,
      },
      {
        name: "Profile & Settings",
        key: "profileAndSettings",
        icon: <Icon fontSize="medium">se</Icon>,
        route: "/myProfile",
        component: <MMProfileAndSettings />,
        accessNumber: PageNumber.ProfileAndSettings,
      },
      {
        name: "Logout",
        key: "logout",
        route: "/sign-in",
        component: <SignInIllustration />,
        accessNumber: PageNumber.Logout,
      },
    ],
  },
  { type: "divider", key: "divider-0" },

  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboards",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    hide: true,
    accessNumber: PageNumber.Dashboard,
    collapse: [
      {
        name: "Dashboard",
        key: "dashboard",
        route: "/dashboard",
        component: <MainDashboard />,
        accessNumber: PageNumber.Dashboard,
      },
    ],
  },
  {
    type: "collapse",
    name: "Brands",
    key: "brands",
    icon: <Layers />,
    accessNumber: PageNumber.Brands,
    collapse: [
      {
        name: "Brands",
        key: "list",
        route: "/brands",
        component: <ViewBrandsList />,
        accessNumber: PageNumber.Brands,
      },
      {
        name: "View Brand",
        key: "viewBrand",
        route: "/brands/:brandName",
        component: <ViewBrand />,
        hide: true,
        accessNumber: PageNumber.ViewBrand,
      },
    ],
  },

  {
    type: "collapse",
    name: "Users",
    key: "Users_dashboard",
    icon: <Icon fontSize="medium">groups</Icon>,
    accessNumber: PageNumber.Users,
    collapse: [
      {
        name: "End users",
        key: "endUsers",
        route: "/endUsers",
        component: <ViewEndUsersList />,
        accessNumber: PageNumber.EndUsers,
        notificationKey: "pendingProfiles",
      },
      {
        name: "View End user",
        key: "viewEndUsers",
        route: "/endUsers/:id",
        hide: true,
        component: <ViewEndUser />,
        accessNumber: PageNumber.ViewEndUser,
      },
      {
        name: "View User Interactions Statistics",
        key: "viewEndUserIntroductions",
        route: "/endUsers/:id/introductions",
        hide: true,
        component: <ViewEndUserIntroductions />,
        accessNumber: PageNumber.ViewUserInteractionsStatistics,
      },
      {
        name: "View User Match Scores",
        key: "viewEndUserMatchScores",
        route: "/endUsers/:id/matchScores",
        hide: true,
        component: <EndUsersMatchScores />,
        accessNumber: PageNumber.ViewUserMatchScores,
      },
      {
        name: "Introductions",
        key: "introductions",
        route: "/introductions",
        component: <IntroductionsScreen />,
        accessNumber: PageNumber.Introductions,
        notificationKey: "pendingIntros",
      },
      {
        name: "View Introduction",
        key: "viewIntroduction",
        route: "/introductions/:id",
        component: <ViewIntroduction />,
        hide: true,
        accessNumber: PageNumber.ViewIntroduction,
      },
      {
        name: "Groups",
        key: "groups",
        route: "/groups",
        component: <GroupsList />,
        accessNumber: PageNumber.Groups,
      },
      {
        name: "View Group",
        key: "viewGroup",
        route: "/groups/:id",
        component: <GroupsView />,
        hide: true,
        },  
      {
        name: "System users",
        key: "system_users",
        route: "/systemUsers",
        component: <ViewSystemUsersList />,
        accessNumber: PageNumber.SystemUsers,
      },
      {
        name: "View System user",
        key: "single_system_users",
        hide: true,
        route: "/systemUsers/:id",
        component: <ViewSystemUser />,
        accessNumber: PageNumber.ViewSystemUser,
      },
      {
        name: "Roles",
        key: "roles_permissions",
        route: "/roles",
        component: <ViewRoles />,
        accessNumber: PageNumber.Roles,
      },
      {
        name: "View Role (Permissions)",
        key: "permissions",
        route: "/roles/:id",
        component: <RolePermissions2 />,
        accessNumber: PageNumber.ViewRolePermissions,
        hide: true,
      },
      {
        name: "Tag Rules",
        key: "tagRules",
        route: "/tagRules",
        component: <TagRulesList />,
        accessNumber: PageNumber.TagRules,
      },
      {
        name: "View Tag Rule",
        key: "viewTagRule",
        route: "/tagRules/:id",
        component: <TagRulesView />,
        accessNumber: PageNumber.TagRules,
        hide: true,
      },
    ],
  },

  {
    type: "collapse",
    name: "Content",
    key: "content",
    icon: <NoteAlt />,
    accessNumber: PageNumber.Content,
    collapse: [
      {
        name: "App content",
        key: "app_content",
        route: "/content",
        component: <Translations />,
        accessNumber: PageNumber.AppContent,
      },
      {
        name: "Communications",
        key: "communications",
        route: "/communications",
        component: <CommsList />,
        accessNumber: PageNumber.Communications,
      },
      {
        name: "One-time comm",
        key: "one_time_comm",
        route: "/communications/one-time",
        component: <CommsList />,
        accessNumber: PageNumber.Communications,
      },
      {
        name: "View Communication",
        key: "communication",
        route: "/communications/:id",
        accessNumber: PageNumber.ViewCommunication,
        component: <CommsView />,
        hide: true,
      },
      {
        name: "Translations list",
        key: "translations_list",
        route: "/translations_list",
        component: <LanguageSettings />,
        accessNumber: PageNumber.TranslationsList,
      },
      {
        name: "Info Screens",
        key: "info_screens",
        route: "/screens",
        component: <ScreensList />,
        accessNumber: PageNumber.InfoScreens,
      },
      {
        name: "View Info Screen",
        key: "info_screen",
        route: "/screens/:id",
        hide: true,
        component: <ScreensView />,
        accessNumber: PageNumber.ViewInfoScreen,
      },
      {
        name: "Positions",
        key: "positions",
        route: "/settings/positions",
        component: <Positions />,
        accessNumber: PageNumber.Positions,
      },
      {
        name: "Lang Translations",
        key: "lang_translations",
        route: "/translations_list/:langCode",
        component: <Translations />,
        accessNumber: PageNumber.LangTranslations,
        hide: true,
      },
    ],
  },

  {
    type: "collapse",
    name: "Questionnaires",
    key: "Questionnaires",
    icon: (
      <Icon fontSize="medium">
        <SettingsApplicationsIcon />
      </Icon>
    ),
    accessNumber: PageNumber.Questionnaires,
    collapse: [
      {
        name: "Questionnaires",
        key: "questionnaires",
        route: "/questionnaires",
        component: <QuestionnaireList />,
        accessNumber: PageNumber.ViewQuestionnaire,
      },
      {
        name: "View Questionnaire",
        key: "questionList",
        route: "/questionnaires/:bname",
        component: <QuestionList />,
        hide: true,
        accessNumber: PageNumber.ViewQuestionnaire,
      },
      {
        name: "Questions List",
        key: "questions",
        route: "/questions",
        component: <BatchList />,
        accessNumber: PageNumber.QuestionsList,
      },
      {
        name: "View Question",
        key: "question",
        hide: true,
        route: "/questions/:id",
        component: <ViewQuestion />,
        accessNumber: PageNumber.ViewQuestion,
      },
      {
        name: "Question Answers List",
        key: "questionAnswers",
        hide: true,
        route: "/questions/:id/answers",
        component: <AnswersListPage />,
        accessNumber: PageNumber.ViewQuestion,
      },
      {
        name: "Attributes List",
        key: "attributes",
        route: "/attributes",
        component: <AttributesList />,
        accessNumber: PageNumber.AttributesList,
      },
      {
        name: "View Attribute",
        key: "attribute",
        route: "/attributes/:id",
        component: <ViewAttribute />,
        hide: true,
        accessNumber: PageNumber.ViewAttribute,
      },
      {
        name: "Predictors",
        key: "predictors",
        route: "/predictors",
        component: <PredictorRelationsList />,
        accessNumber: PageNumber.Predictors,
      },
      {
        name: "Auto Complete Answers",
        key: "auto_complete_answers",
        route: "/attributes/:id/autocompleteAnswers",
        component: <AutocompleteAnswers />,
        accessNumber: PageNumber.AutoCompleteAnswers,
        hide: true,
      },
      {
        name: "Edit Batch Content",
        key: "editBatchContent",
        route: "/batch-content/:id/edit",
        component: <EditBatchContent />,
        hide: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Lora",
    key: "lora",
    icon: (
      <Icon fontSize="medium">
        <SettingsApplicationsIcon />
      </Icon>
    ),
    accessNumber: PageNumber.Lora,
    collapse: [
      {
        name: "Screen flow mgmt",
        key: "screen_flow_mgmt",
        route: "/screen_flow_mgmt",
        component: <EmptyPage />,
        accessNumber: PageNumber.ScreenFlowMgmt,
      },
      {
        name: "Content / order",
        key: "content_order",
        route: "/content_order",
        component: <EmptyPage />,
        accessNumber: PageNumber.ContentOrder,
      },
      {
        name: "Settings / algorithm",
        key: "Settings_algorithm",
        route: "/settings_algorithm",
        component: <EmptyPage />,
        accessNumber: PageNumber.SettingsAlgorithm,
      },
      {
        name: "AI Simulations",
        key: "AISimulations",
        route: "/AISimulations",
        component: <AISimulationsList />,
        accessNumber: PageNumber.AISimulations,
      },
      {
        name: "View AI Simulation",
        key: "viewAISimulation",
        route: "/AISimulations/:id",
        hide: true,
        component: <AISimulationsView />,
      }
    ],
  },
  {
    type: "collapse",
    name: "Support Center",
    key: "support_enter",
    icon: (
      <Icon fontSize="medium">
        <SettingsApplicationsIcon />
      </Icon>
    ),
    accessNumber: PageNumber.SupportCenter,
    collapse: [
      {
        name: "Customer Support Tickets",
        key: "customer_support_tickets",
        route: "/tickets/customerSupport",
        component: (
          <CustomerSupportTickets source={TicketSource.MobileApp} key={TicketSource.MobileApp} />
        ),
        accessNumber: PageNumber.CustomerSupportTickets,
        notificationKey: "openTicketsMobile",
      },
      {
        name: "System Tickets",
        key: "system_support_tickets",
        route: "/tickets/system",
        component: (
          <CustomerSupportTickets source={TicketSource.AdminPanel} key={TicketSource.AdminPanel} />
        ),
        accessNumber: PageNumber.SystemTickets,
        notificationKey: "openTicketsAdmin",
      },
      {
        name: "Customer Support Settings",
        key: "customer_support_settings",
        route: "/customerSupportSettings",
        component: <CustomerSupportSettings />,
        accessNumber: PageNumber.CustomerSupportSettings,
      },
      {
        name: "Customer Support Ticket View",
        key: "customer_support_ticket_view",
        route: "/tickets/:source/:ticketID",
        component: <CustomerSupportViewTicket />,
        accessNumber: PageNumber.CustomerSupportTicketView,
        hide: true,
      },
      {
        name: "Create New Ticket",
        key: "create_new_ticket",
        route: "/customerSupportTickets/new",
        component: <CreateNewTicket />,
      },
    ],
  },
  {
    type: "collapse",
    name: "SME Marketplace",
    key: "SME_marketplace",
    icon: (
      <Icon fontSize="medium">
        <SettingsApplicationsIcon />
      </Icon>
    ),
    accessNumber: PageNumber.SMEMarketplace,
    collapse: [
      {
        name: "Shidduch Requests",
        key: "shidduchRequests",
        route: "/shidduch-requests",
        component: <ShidduchRequests />,
        accessNumber: PageNumber.ShidduchRequests,
      },
      {
        name: "Shidduch Request View",
        key: "shidduchRequestView",
        route: "/shidduch-requests/:id",
        component: <ShidduchRequestView />,
        accessNumber: PageNumber.ShidduchRequestView,
        hide: true,
      },
      {
        name: "Shidduch Declines",
        key: "shidduchDeclines",
        route: "/shidduch-declines",
        component: <DeclinesList />,
        accessNumber: PageNumber.ShidduchDeclines,
      },
      {
        name: "SME Profiles",
        key: "smeProfiles",
        route: "/smeProfiles",
        component: <SMEProfiles />,
        accessNumber: PageNumber.SMEProfiles,
      },
      {
        name: "View SME Profile",
        key: "profileAndSettings",
        icon: <Icon fontSize="medium">se</Icon>,
        route: "/smeProfiles/:id",
        component: <MMProfileAndSettings />,
        hide: true,
        accessNumber: PageNumber.ViewSMEProfile,
      },
    ],
  },

  {
    type: "collapse",
    name: "Content Center",
    key: "content_center",
    icon: (
      <Icon fontSize="medium">
        <SettingsApplicationsIcon />
      </Icon>
    ),
    accessNumber: PageNumber.ContentCenter,
    collapse: [
      {
        name: "Types",
        key: "contentsCenterTypes",
        route: "/contentsCenter",
        component: <ContentTypes />,
        accessNumber: PageNumber.ContentCenterList,
      },
      {
        name: "List",
        key: "contentsCenter",
        route: "/contentsCenter/:type",
        component: <ContentsList />,
        accessNumber: PageNumber.ContentCenterList,
        hide: true,
      },
      {
        name: "View Content",
        key: "content",
        route: "/contentsCenter/:type/:id",
        component: <ContentsView />,
        accessNumber: PageNumber.ViewContent,
        hide: true,
      },
    ],
  },

  {
    type: "collapse",
    name: "Brand Settings",
    key: "settings",
    icon: <SettingsApplicationsIcon />,
    accessNumber: PageNumber.Settings,
    collapse: [{
      name: "Loading Settings",
      key: "loadingSettings",
      route: "/brandSettings/:id",
      component: <SystemSettings />,
      accessNumber: PageNumber.Settings,
    },],
  },
  {
    type: "collapse",
    name: "Admin Settings",
    key: "adminSettings",
    icon: <SettingsApplicationsIcon />,
    accessNumber: PageNumber.General,
    collapse: [
      ...Object.values(SettingsTypes).map((type) => ({
        name: Object.keys(SettingsTypes).find((key) => SettingsTypes[key] === type),
        key: type,
        route: `/settings/${type}`,
        component: <AppSettings type={type} />,
        accessNumber: PageNumber.General,
      })),
      {
        name: "Profile Images",
        key: "profileImages",
        type: "collapse",
        notificationKey: 'pendingAssets',
        accessNumber: PageNumber.General,
        collapse: [{

          name: "Images List",
          key: "profileAssetsList",
          route: "/settings/profile-images",
          notificationKey: 'pendingAssets',
          component: <ProfileAssetsList />,
          accessNumber: PageNumber.General,
        },
        {
          name: "Images Settings",
          key: "profileImagesSettings",
          route: "/brandSettings/1",
          component: <SystemSettings pageId="1"/>,
          accessNumber: PageNumber.General,
        },
        ],
      },
      {
        name: "General Codes",
        key: "generalCodes",
        route: "/general-codes",
        component: <GeneralCodesTable />,
        accessNumber: PageNumber.General,
      },
      {
        name: "Bo Settings Pages",
        key: "boSettingsPages",
        route: "/boSettingsPages",
        component: <BoSettingsPagesList />,
        accessNumber: PageNumber.General,
      },
      {
        name: "Add Bo Settings Page",
        key: "addBoSettingsPage",
        route: "/boSettingsPages/:id",
        hide: true,
        component: <BoSettingsPagesView />,
        accessNumber: PageNumber.General,
      },
    ],
  },

  {
    type: "collapse",
    name: "Reports",
    key: "Reports",
    icon: (
      <Icon fontSize="medium">
        <SettingsApplicationsIcon />
      </Icon>
    ),
    accessNumber: PageNumber.Reports,
    collapse: [
      {
        name: "Users",
        key: "users-report",
        route: "/reports/users",
        component: <ReportPage type="users" />,
        accessNumber: PageNumber.UsersReport,
      },
      {
        name: "Questions",
        key: "questions-report",
        route: "/reports/questions",
        component: <ReportPage type="questions" />,
        accessNumber: PageNumber.QuestionsReport,
      },
      {
        name: "Chats",
        key: "chats-report",
        route: "/reports/chats",
        feature: AppFeature.chat,
        component: <ReportPage type="chats" />,
        accessNumber: PageNumber.ChatsReport,
      },
      {
        name: "Communications",
        key: "communications-report",
        route: "/reports/communications",
        component: <ReportPage type="communications" />,
        accessNumber: PageNumber.CommunicationsReport,
      },
      {
        name: "Interactions",
        key: "interactions-report",
        route: "/reports/interactions",
        component: <ReportPage type="interactions" />,
        accessNumber: PageNumber.InteractionsReport,
      },
      {
        name: "Customer Support",
        key: "customer-support-report",
        route: "/reports/customerSupport",
        component: <ReportPage type="customer_support" />,
        accessNumber: PageNumber.CustomerSupportReport,
      },
      {
        name: "Devices",
        key: "devices-report",
        route: "/reports/devices",
        component: <ReportPage type="devices" />,
        accessNumber: PageNumber.DevicesReport,
      },
    ],
  },

  {
    type: "collapse",
    name: "Marketing",
    key: "marketing",
    icon: (
      <Icon fontSize="medium">
        <SettingsApplicationsIcon />
      </Icon>
    ),
    accessNumber: PageNumber.Marketing,
    collapse: [
      {
        name: "Empty2",
        key: "empty2",
        route: "/empty2",
        component: <EmptyPage />,
        accessNumber: PageNumber.Empty2,
      },
    ],
  },

  {
    type: "collapse",
    name: "Premium settings",
    key: "premium_settings",
    icon: (
      <Icon fontSize="medium">
        <SettingsApplicationsIcon />
      </Icon>
    ),
    accessNumber: PageNumber.PremiumSettings,
    collapse: [
      {
        name: "Top level",
        key: "Top_level",
        route: "/top_level",
        component: <EmptyPage />,
        accessNumber: PageNumber.TopLevel,
      },
      {
        name: "Brand level",
        key: "Brand_level",
        route: "/brand_level",
        component: <EmptyPage />,
        accessNumber: PageNumber.BrandLevel,
      },
    ],
  },

  {
    type: "collapse",
    name: "Authentication",
    key: "authentication",
    icon: <Icon fontSize="medium">content_paste</Icon>,
    collapse: [
      {
        name: "Sign In",
        key: "sign-in",
        collapse: [
          {
            name: "Illustration",
            key: "illustration",
            route: "/sign-in",
            component: <SignInIllustration />,
          },
          {
            name: "Error",
            key: "error",
            route: "/error",
            component: <ErrorPage />,
          },
        ],
      },
    ],
  },
];

export default routes;
